import PropTypes from 'prop-types';
import React, { useState } from 'react';

import DealMakingModal from '@modals/DealMakingModal';

export const COOKIE_NAME = 'icsc_deal_modal_skip';

export const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * (60 * 60 * 24 * 1000)).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

const DealMakingModalGlobal = ({ eligibleEvents }) => {
    const [isOpen, setIsOpen] = useState(true);

    const handleClose = () => {
        setIsOpen(false);
        setCookie(COOKIE_NAME, '1', 30);
    };

    return <DealMakingModal isOpen={isOpen} events={eligibleEvents} onClose={handleClose} />;
};

DealMakingModalGlobal.propTypes = {
    eligibleEvents: PropTypes.array.isRequired,
};

export default DealMakingModalGlobal;
